<template>
  <div class="row row-inside mt-4">
    <div class="flex md3">{{ quarterName }} {{filterText}}</div>
    <div class="flex md2">
      <va-button class="fullwidth" small :color="reportGenerated ? 'success' : 'info'"
        :disabled="!reportAvailable || reportGenerated" @click="generateRapport()">Rapport</va-button>
    </div>
    <div class="flex md2">
      <va-button class="fullwidth" small :disabled="!reportGenerated" :color="reportGenerated ? 'success' : 'info'"
        @click="getReportInfos">Afficher le rapport</va-button>
    </div>

    <div class="flex md12">
      <va-data-table ref="dataTable" class="va-table--hoverable va-table--stripped" :fields="fields"
        :data="filteredData" :no-data-label="noDataLabel" :per-page="10" @row-clicked="showEntreprise" clickable>
        <template slot="nom_entreprise" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md12 mb-0 pb-0 nom-dirigeant" v-bind:class="{
            cancelled: props.rowData.cancelled}">
              {{ props.rowData.nom_entreprise }}
            </div>
          </div>
        </template>
        <template slot="nom_dirigeant" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md12 mb-0 pb-0 nom-dirigeant" v-bind:class="{
              cancelled: props.rowData.cancelled,

            }">
              {{ formatNomDirigeant(props.rowData) }}
            </div>
            <div class="flex md12 mt-0 pt-0 nom-societe" v-if="props.rowData.titre === 'SOCIÉTÉ'" >
              {{ formatNomSociete(props.rowData) }}
            </div>
          </div>
        </template>

        <template slot="adresse" slot-scope="props">
          <div class="row row-inside" >
            <div class="flex md12 mb-0 pb-0 nom-dirigeant" v-if="props.rowData.adresse">
              {{ props.rowData.adresse }}
            </div>
            <div class="flex md12 my-0 py-0 nom-dirigeant" v-if="props.rowData.complement">
              {{ props.rowData.complement }}
            </div>
            <div class="flex md12 mt-0 pt-0 nom-dirigeant">
              {{ formatAdresse(props.rowData) }}
            </div>
          </div>
        </template>
        <template slot="adhesion" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md12 mb-0 pb-0 nom-societe">Début d'adhésion:</div>
            <div class="flex md12 my-0 py-0 nom-dirigeant">
              {{ props.rowData.date_adhesion }}
            </div>
            <div class="flex md12 mt-0 pt-0 nom-societe">
              {{ FormatPaiementType(props.rowData) }}
            </div>
          </div>
        </template>

        <template slot="montant" slot-scope="props">
          <div class="row row-inside" v-bind:class="{
            cancelled: props.rowData.cancelled}">
            <div class="flex md12 mb-0 pb-0">{{ props.rowData.montant }}€</div>
            <div class="flex md12 mt-0 pt-0 nom-societe" v-if="props.rowData.mapa === 1">
              Avec MAPA
            </div>
          </div>
        </template>
        <template slot="email_warning" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md12">
              <va-button class="fullwidth" small :disabled="colorCourriel(props.rowData) === 'success' || actionLive"
                :color="colorCourriel(props.rowData)" @click="sendCourrielWarning(props.rowData)">{{
                textCourriel(props.rowData) }}</va-button>
            </div>
          </div>
        </template>
        <template slot="prelevement_status" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md12" >
              <!-- Disable if prelevement is done or if email not send or if send less than a week -->
              <va-toggle small :disable="
                checkPrelevementOk(props.rowData) ||
                (props.rowData.prelevement &&
                  !!props.rowData.prelevement.date_prelevement) || actionLive
              " :value="
                  props.rowData.prelevement &&
                  !!props.rowData.prelevement.date_prelevement
                " @input="updatePrelevement(props.rowData)" />
            </div>
          </div>
        </template>
        <template slot="date_prelevement" slot-scope="props">
          <div class="row row-inside" >
            <div class="flex md12" v-if="props.rowData.prelevement" v-bind:class="{
              cancelled: props.rowData.cancelled,

            }">
              {{ textDatePrelevement(props.rowData) }}
            </div>
                <div class="flex md12" v-if="props.rowData.cancelled && (!props.rowData.prelevement || !props.rowData.prelevement.date_effectif)" v-bind:class="{
              cancelled: props.rowData.cancelled,

            }">
              PRELEVEMENT ANNULE
            </div>
          </div>
        </template>
        <template slot="received" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md12 mb-0 pb-0">
              <va-toggle small :disable="checkRecuOk(props.rowData) || actionLive" :value="
                props.rowData.prelevement &&
                !!props.rowData.prelevement.date_effectif
              " @input="updateReceivedPaiement(props.rowData)" />
            </div>
            <div class="flex md12 mt-0 pt-0 nom-societe" v-if="props.rowData.prelevement &&
            !!props.rowData.prelevement.date_effectif">
              {{ props.rowData.prelevement.user_paiement }}
            </div>
          </div>
        </template>
        <template slot="actions" slot-scope="props">
          <div class="row row-inside">
            <div class="flex md6">
              <va-popover message="Reçus" placement="top">
                <va-button class="selection-refresh" flat
                  :disabled="!props.rowData.prelevement || !props.rowData.prelevement.date_effectif"
                  :color="(props.rowData.prelevement && props.rowData.prelevement.date_recu) || props.rowData.date_envoi_recu?'success':'info'"
                  icon="fa fa-bookmark" @click="openRecu(props.rowData)" />
              </va-popover>
            </div>
            <div class="flex md6">
              <va-popover message="Annuler le prélèvement" placement="left">
                <va-button class="selection-refresh" flat
                  :disabled="props.rowData.prelevement && props.rowData.prelevement.date_effectif" color="danger"
                  icon="fa fa-close" @click="openCancel(props.rowData)" />
              </va-popover>
            </div>
          </div>
        </template>
      </va-data-table>
    </div>
    <va-modal class="modal" v-model="showModal" max-width="100%" hideDefaultActions>
      <p class="MsoNormal" align="center" style="text-align: center">
        <span lang="FR">******

          <p></p>
        </span>
      </p>
      <p class="MsoNormal" align="center" style="text-align: center">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse">
        <tr style="height: 19.5pt">
          <td width="626" colspan="2" style="
              width: 469.2pt;
              border: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 19.5pt;
            ">
            <p class="MsoNormal" align="center" style="text-align: center">
              <b>
                <span lang="FR">Rapport de campagne de prélèvement {{ infoCampagne }}

                  <p></p>
                </span>
              </b>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Nombre d’adhérents prélevés&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ nbTot }}

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 19.5pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 19.5pt;
            ">
            <p class="MsoNormal">
              Montant total prélevé&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 19.5pt;
            ">
            <p class="MsoNormal">
              {{ monTot }} €

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Adhérents annuel&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ nbAnTot }} ({{ nbAnUnpf }} UNPF – {{ nbAnSpef }} SPEF)

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Adhérents trimestriel

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ nbTrTot }} ({{ nbTrUnpf }} UNPF – {{ nbTrSpef }} SPEF)

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Adhérents SPEF&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ nbSpef }}

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Adhérents UNPF&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ nbUnpf }}

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Montant SPEF&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ moSpef }} €

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Montant UNPF&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ moUnpf }} €

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              MAPA&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ nbMapaTot }} ({{ nbMapaUnpf }} UNPF – {{ nbMapaSpef }} SPEF)

            <p></p>
            </p>
          </td>
        </tr>
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              border-top: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              MAPA encaissements&nbsp;:

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border-top: none;
              border-left: none;
              border-bottom: solid windowtext 1pt;
              border-right: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              {{ moMapaTot }} € ({{ moMapaUnpf }} € UNPF – {{ moMapaSpef }} €
              SPEF)

            <p></p>
            </p>
          </td>
        </tr>
      </table>
      <p class="MsoNormal" align="center" style="text-align: center">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p class="MsoNormal" align="center" style="text-align: center">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span lang="FR">Liste des adhérents prélevés&nbsp;:

            <p></p>
          </span>
        </b>
      </p>

      <p v-for="element in listPre">{{ element }}</p>

      <p class="MsoNormal">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span lang="FR">Virement à effectuer SPEF =&gt; UNPF&nbsp;:

            <p></p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse">
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Encaissements

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border: solid windowtext 1pt;
              border-left: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              <!-- encaissementUnpf à corriger plus globalement -->
              {{ moUnpf }} €

            <p></p>
            </p>
          </td>
        </tr>
      </table>
      <p class="MsoListParagraph">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span lang="FR">Virement à effectuer SPEF =&gt; OPEF&nbsp;:

            <p></p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse">
        <tr style="height: 18.7pt">
          <td width="236" style="
              width: 176.9pt;
              border: solid windowtext 1pt;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              Encaissements

            <p></p>
            </p>
          </td>
          <td width="390" style="
              width: 292.3pt;
              border: solid windowtext 1pt;
              border-left: none;
              padding: 0cm 5.4pt 0cm 5.4pt;
              height: 18.7pt;
            ">
            <p class="MsoNormal">
              <!-- encaissementOpef à corriger plus globalement -->
              {{ moMapaTot }} €

            <p></p>
            </p>
          </td>
        </tr>
      </table>
      <p class="MsoListParagraph">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p class="MsoNormal">
        <span lang="FR">
          <p>&nbsp;</p>
        </span>
      </p>
      <p class="MsoNormal" align="center" style="text-align: center">
        <span lang="FR">******

          <p></p>
        </span>
      </p>
      <p class="MsoNormal">
      <p>&nbsp;</p>
      </p>
    </va-modal>
    <recu-manager title="Reçu d'adhésion" :idadhesion="showRecuID" :trimestreStart="trimestreStart" v-model="showRecu"
      v-on:cancel="resetRecu" v-on:ok="addRecuOk(showRecuID)" />
    <va-modal class="modal modal-cancel" v-model="showCancel" max-width="100%" v-on:cancel="resetCancel"
      v-on:ok="cancelPrelevement" okText="Confirmer l'annulation" cancelText="Retour">
      <div class="row row-inside">
        <div class="flex md12 mb-2">
          <h3>Arrêter les prélèvements pour {{cancelName}}</h3>
        </div>
        <div class="flex md12">
          <va-radio-button v-model="cancelOption" option="cancel" label="Arrêt de l'adhésion" />
        </div>
        <div class="flex md12">
          <va-radio-button v-model="cancelOption" option="offert" label="Offrir la fin de l'adhésion" />
        </div>
        <div class="flex md12 mt-4">
          <p>Cette action arrête également le renouvellement automatique de l'adhésion. Un commentaire sera rajouté dans
            la fiche de l'entreprise</p>
        </div>
      </div>
    </va-modal>
  </div>


</template>



<script>
import axios from "axios"
import moment from "moment"
import { cloneDeep, debounce, findIndex, deburr } from "lodash"
import RecuManager from "../dashboard/components/RecuManager"

//todo mode summary to own component

export default {
  name: "prelevement-trimestre",
  props: ["trimestreStart", "updateKey", "startPage", "filter", "filterText"],
  components: {
    RecuManager,
  },
  data() {
    return {
      actionLive: false,
      action: false,
      noDataLabel: "Chargement en cours",
      listPrelevement: [],
      reportGenerated: false,
      showModal: false,
      infoCampagne: null,
      nbTot: null,
      monTot: null,
      nbAnTot: null,
      nbTrTot: null,
      nbAnUnpf: null,
      nbAnSpef: null,
      nbTrUnpf: null,
      nbTrSpef: null,
      nbSpef: null,
      nbUnpf: null,
      moSpef: null,
      moUnpf: null,
      nbMapaTot: null,
      nbMapaUnpf: null,
      nbMapaSpef: null,
      encaissementUnpf: null,
      moMapaTot: null,
      encaissementOpef: null,
      moMapaUnpf: null,
      moMapaSpef: null,
      listPre: null,
      showRecu: false,
      showRecuID: null,
      showCancel: false,
      cancelName: "",
      cancelIdPaiement: null,
      cancelOption: "cancel",
    }
  },
  created() {
    moment.locale("fr")
    //load trimesterList
    this.getTrimesterList()
      .then((result) => { })
      .catch((err) => {
        this.noDataLabel = "Erreur de chargement"
      })
  },
  mounted() {
    // this.$nextTick(function () {
    //   console.log("tata");
    //   let page = this.startPage ? parseInt(this.startPage) : 1;
    //   this.switchPage(page);
    // });
  },
  methods: {
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      })
    },
    addRecuOk(idadhesion) {
      // set a date for sending the receit so it display green until following update
      let indexAdhesion = findIndex(this.listPrelevement, {
        idadhesion: idadhesion,
      })
      this.listPrelevement[indexAdhesion].prelevement.date_recu =
        moment().format("YYYY-MM-DD")
    },
    resetRecu() {
      this.showRecuID = null
    },
    resetCancel() {
      this.cancelName = ""
      this.cancelIdPaiement = null
    },
    async cancelPrelevement() {
      try {
        this.actionLive = true
        if (
          !this.cancelIdPaiement ||
          (this.cancelOption !== "cancel" && this.cancelOption !== "offert")
        ) {
          this.launchEpicmaxToast("Une erreur à été rencontrée")
        }

        let params = {
          idpaiement: this.cancelIdPaiement,
          userChoice: this.cancelOption,
        }
        let res = await axios.put(
          "/api/prelevements/cancelPrelevement",
          params
        )
        // element.prelevement = res.data;
        let page = this.currentPage;
        // let i = findIndex(this.listPrelevement, ["idKey", element.idKey]);
        // this.$set(this.listPrelevement, i, element);
        this.switchPage(page);
        this.actionLive = false
        this.getTrimesterList()
        this.launchEpicmaxToast("Prélèvement annulé")
      } catch (error) {
        // emit message
        this.launchEpicmaxToast("Une erreur à été rencontrée")
        console.log(error.response)
      }
    },
    openCancel(rowData) {
      this.action = true
      this.cancelName = rowData.nom_entreprise
      this.cancelIdPaiement = rowData.idpaiement
      this.showCancel = true
    },
    openRecu(rowData) {
      this.action = true
      this.showRecuID = rowData.idadhesion
      this.showRecu = true
    },
    async generateRapport() {
      try {
        let params = { startDate: this.trimestreStart }
        let res = await axios.post("/api/prelevements/generateReport", params)
        if (res.data.report) {
          this.reportGenerated = true
        }
      } catch (error) {
        // emit message

        console.log(error.response)
      }
    },
    checkRecuOk(element) {
      // allow to lock the recu checkbox if prelevement is not done or if reception have already been marked as ok
      if (
        element.prelevement &&
        element.prelevement.date_prelevement &&
        !element.prelevement.date_effectif
      ) {
        return false
      } else {
        return true
      }
    },
    checkPrelevementOk(element) {
      //TODO remove before prod
      if (!element.prelevement) {
        return true
        // } else if (
        //   moment(element.prelevement.date_planned_prelevement).isSameOrBefore(
        //     moment()
        //   )
        // ) {
        //   return false;
      } else {
        return false
      }
    },
    async updateReceivedPaiement(element) {
      this.action = true
      try {
        this.actionLive = true
        let params = { idprelevement: element.prelevement.idprelevement }
        let res = await axios.put("/api/prelevements/setReceived", params)
        element.prelevement = res.data
        let page = this.currentPage
        let i = findIndex(this.listPrelevement, ["idKey", element.idKey])
        this.$set(this.listPrelevement, i, element)
        this.switchPage(page)
        this.actionLive = false
      } catch (error) {
        this.actionLive = true
        console.log(error)
      }
    },
    async updatePrelevement(element) {
      this.action = true

      try {
        this.actionLive = true
        // // StartOfTemp
        // allow prelevement without sending email
        // let resTmp = await this.createPrelevementSansEmail(element);
        // console.log(resTmp);
        // element.prelevement = resTmp;
        // console.log(element);
        // // EndOfTemp
        let params = { idprelevement: element.prelevement.idprelevement }
        let res = await axios.put("/api/prelevements/setPrelevement", params)
        element.prelevement = res.data
        let page = this.currentPage
        let i = findIndex(this.listPrelevement, ["idKey", element.idKey])
        this.$set(this.listPrelevement, i, element)
        this.switchPage(page)
        this.actionLive = false
      } catch (error) {
        this.actionLive = false
        console.log(error)
      }
    },
    textDatePrelevement(element) {
      if (!element.prelevement) return
      if (element.prelevement.date_prelevement) {
        let datePrelevement = moment(
          element.prelevement.date_prelevement
        ).format("DD/MM/YYYY")
        return (
          "Prélèvement le " +
          datePrelevement +
          " par " +
          element.prelevement.user_prelevement
        )
      } else {
        let datePrelevement = moment(
          element.prelevement.date_planned_prelevement
        ).format("DD/MM/YYYY")
        return "Prélèvement à effectuer le " + datePrelevement
      }
    },
    textCourriel(element) {
      if (!element.prelevement) {
        return "Courriel"
      } else {
        let dateEnvoi = moment(element.prelevement.date_relance).format(
          "DD/MM/YYYY"
        )
        return dateEnvoi + " par " + element.prelevement.user_relance
      }
    },
    colorCourriel(element) {
      if (!element.prelevement) {
        return "info"
      } else {
        return "success"
      }
    },
    // temporary to treat the backlog
    async createPrelevementSansEmail(entreprise) {
      try {
        this.action = true
        if (entreprise.prelevement) {
          return
        }
        let params = {
          idpaiement: entreprise.idpaiement,
          trimesterStart: this.trimestreStart,
        }
        let res = await axios.put("/api/prelevements/createNoEmail", params)
        return res.data
      } catch (error) {
        console.log(error.response)
      }
    },
    async sendCourrielWarning(entreprise) {
      try {
        this.actionLive = true
        this.action = true
        if (entreprise.prelevement) {
          this.actionLive = false
          return
        }
        let params = {
          idpaiement: entreprise.idpaiement,
          trimesterStart: this.trimestreStart,
        }
        let res = await axios.put("/api/prelevements/warningEmail", params)

        entreprise.prelevement = res.data
        let page = this.currentPage
        let i = findIndex(this.listPrelevement, ["idKey", entreprise.idKey])
        this.$set(this.listPrelevement, i, entreprise)
        this.switchPage(page)
        this.actionLive = false
      } catch (error) {
        this.actionLive = false
        console.log(error.response)
        // todo warning displayed
      }
    },
    FormatPaiementType(entreprise) {
      if (entreprise.idpaiement_type === 5) {
        return "1 prélèvement"
      }
      if (entreprise.idpaiement_type === 6) {
        return "4 prélèvements"
      }
      if (entreprise.idpaiement_type === 8) {
        return "prélèvements arrêtés"
      }
    },
    formatAdresse(object) {
      let adresse = {
        code_postal: object.code_postal ? object.code_postal + " " : "",
        ville: object.ville ? object.ville + " " : "",
        cedex: object.cedex ? object.cedex : "",
      }

      return adresse.code_postal + adresse.ville + adresse.cedex
    },
    formatNomSociete(entreprise) {
      let object = cloneDeep(entreprise)

      object.titre = object.titre_societe ? object.titre_societe : null
      object.nom = object.nom_societe ? object.nom_societe : null
      object.prenom = object.prenom_societe ? object.prenom_societe : null

      return this.formatNomDirigeant(object)
    },
    formatNomDirigeant(entreprise) {
      let object = cloneDeep(entreprise)
      // abreviation classique :
      object.titre = object.titre === "SOCIÉTÉ" ? "Sté." : object.titre
      object.titre = object.titre === "MONSIEUR" ? "M." : object.titre
      object.titre = object.titre === "MADAME" ? "Mme" : object.titre

      let nameWritten = object.titre ? object.titre.toUpperCase() : ""
      nameWritten = object.nom
        ? nameWritten + " " + object.nom.toUpperCase()
        : nameWritten

      nameWritten = object.prenom
        ? nameWritten + " " + object.prenom.toUpperCase()
        : nameWritten

      return nameWritten
    },
    showEntreprise(entreprise) {
      if (!this.action) {
        this.$emit("showEntreprise", entreprise)
      }
      this.action = false
    },
    async getTrimesterList() {
      try {
        let results = await axios.get("/api/prelevements/trimester", {
          params: { dateDebut: this.trimestreStart },
        })
        let data = results.data
        this.reportGenerated = results.data.report
        if (data.list.length === 0) {
          this.noDataLabel = "Aucun prélévement pour ce trimestre"
        }
        let ijk = 0
        data.list.forEach((element) => {
          element.idKey = ijk
          ijk += 1
        })

        this.listPrelevement = data.list
      } catch (error) {
        console.log(error)
        return []
      }
    },
    async getReportInfos() {
      try {
        let results = await axios.get("/api/prelevements/getReportInfos", {
          params: { startQuarter: this.trimestreStart },
        })
        let report = results.data.report

        let nbTot =
          report.nb_annuel_spef +
          report.nb_annuel_unpf +
          report.nb_trimestriel_spef +
          report.nb_trimestriel_unpf
        let nbSpef = report.nb_annuel_spef + report.nb_trimestriel_spef
        let nbUnpf = report.nb_annuel_unpf + report.nb_trimestriel_unpf
        let nbAnTot = report.nb_annuel_spef + report.nb_annuel_unpf
        let nbTrTot = report.nb_trimestriel_spef + report.nb_trimestriel_unpf
        let monTot = report.montant_spef + report.montant_unpf
        let nbMapaTot = report.mapa_spef + report.mapa_unpf
        let moMapaTot = report.montant_mapa_spef + report.montant_mapa_unpf
        let encaissementOpef = moMapaTot

        this.infoCampagne = this.quarterName
        this.nbTot = nbTot
        this.monTot = monTot
        this.nbAnTot = nbAnTot
        this.nbTrTot = nbTrTot
        this.nbAnUnpf = report.nb_annuel_unpf
        this.nbAnSpef = report.nb_annuel_spef
        this.nbTrUnpf = report.nb_trimestriel_unpf
        this.nbTrSpef = report.nb_trimestriel_spef
        this.nbSpef = nbSpef
        this.nbUnpf = nbUnpf
        this.moSpef = report.montant_spef
        this.moUnpf = report.montant_unpf
        this.nbMapaTot = nbMapaTot
        this.nbMapaUnpf = report.mapa_unpf
        this.nbMapaSpef = report.mapa_spef
        this.encaissementUnpf = report.encaissement_unpf
        this.moMapaTot = moMapaTot
        this.encaissementOpef = encaissementOpef
        this.moMapaUnpf = report.montant_mapa_unpf
        this.moMapaSpef = report.montant_mapa_spef

        this.listPre = results.data.list

        this.showModal = true
      } catch (error) {
        console.log(error)
        // todo
      }
    },
    switchPage: debounce(function (page) {
      console.log("switching", page)
      this.$refs.dataTable.currentPage = page
      this.$refs.dataTable.inputPage(page.toString())
    }, 400),
  },
  watch: {
    async updateKey() {
      await this.getTrimesterList()
    },
    async trimestreStart(newValue) {
      await this.getTrimesterList()
    },
  },
  computed: {
    currentPage() {
      return this.$refs.dataTable.currentPage
    },
    reportAvailable() {
      if (
        moment().isSameOrBefore(moment(this.trimestreStart).endOf("quarter"))
      ) {
        return false
      }

      let awaiting = this.listPrelevement.filter((element) => {
        // in case prelevement was cancelled let report be generated
        if ((!element.prelevement || !element.prelevement.date_effectif) && !element.cancelled) {
          return true
        } else {
          return false
        }
      })
      if (awaiting.length > 0) return false

      return true
    },
    quarterName() {
      let quarter = moment(this.trimestreStart).quarter()
      let year = moment(this.trimestreStart).year()
      let quarterStart = moment(this.trimestreStart).startOf("quarter")
      let months =
        moment(quarterStart).format("MMM") +
        " - " +
        moment(quarterStart).add(1, "month").format("MMM") +
        " - " +
        moment(quarterStart).add(2, "month").format("MMM")

      return "Trimestre " + quarter + " " + year + " (" + months + ")"
    },
    filteredData() {
      console.log(this.listPrelevement)
      let filteredData = this.listPrelevement.filter((item) => {
        let boolcond = true
        if (!this.filter || this.filter === "all") {
          boolcond = true
        }

        if (this.filter === "year" && item.idpaiement_type !== 5) {
          boolcond = false
        } else if (this.filter === "quarter" && item.idpaiement_type !== 6) {
          boolcond = false
        }
        if (this.filterText && this.filterText.length >= 1 && boolcond) {
          let nomCpre = deburr(this.filterText).toLowerCase()
          boolcond =
            boolcond &&
            (deburr(item.nom).toLowerCase().includes(nomCpre) ||
              deburr(item.nom_societe).toLowerCase().includes(nomCpre) ||
              deburr(item.syndicat_name).toLowerCase().includes(nomCpre) ||
              deburr(item.prenom).toLowerCase().includes(nomCpre) ||
              (item.email && item.email.includes(nomCpre)) ||
              (item.adresse && item.adresse.includes(nomCpre)) ||
              item.code_postal.toLowerCase().startsWith(nomCpre) ||
              deburr(item.ville).toLowerCase().includes(nomCpre))
        }

        return boolcond
      })

      return filteredData
    },
    fields() {
      return [
        {
          name: "__slot:nom_entreprise",
          title: "Nom entreprise",
          sortField: "nom_entreprise",
          width: "10%",
        },
        { name: "__slot:nom_dirigeant", title: "Dirigeant", width: "10%" },
        // { name: "__slot:adresse", title: "Adresse", width: "10%" },

        {
          name: "__slot:code_postal",
          title: this.$t("poissonnierTable.headings.code_postal"),
          sortField: "code_postal",
          width: "5%",
        },
        { name: "__slot:adhesion", title: "Adhésion", width: "10%" },
        { name: "__slot:montant", title: "Montant à prélever", width: "5%" },
        {
          name: "__slot:email_warning",
          title: "Courriel avertissement",
          width: "10%",
        },
        {
          name: "__slot:prelevement_status",
          title: "Prélèvement effectué",
          width: "5%",
        },
        {
          name: "__slot:date_prelevement",
          title: "Date prélèvement",
          width: "15%",
        },
        { name: "__slot:received", title: "Montant reçu", width: "10%" },
        {
          name: "syndicat_name",
          title: "Syndicat",
          sortField: "syndicat_name",
          width: "10%",
        },
        { name: "__slot:actions", width: "10%" },
      ]
    },
  },
}
</script>

<style lang="scss">
.nom-dirigeant {
  font-size: 0.8rem;
}

.nom-societe {
  font-size: 0.7rem;
}

.cancelled {
  color: red;
}
</style>
